import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import TextInput from "../../Common/FormElements/TextInput/TextInput";
import { infoElements } from "./data";
import { useSelector } from "react-redux";

const TransporterInformations = ({ forms, setForms }) => {
  const { t } = useTranslation("common");
  const [errors, setErrors] = useState({});
  const { transporter } = useSelector((state) => state?.transporterReducer);
  const isUpdate = !!transporter;

  const handleInputChange = (name, value) => {
    const isUserField = name === "email" || name === "password";

    setForms((prev) => ({
      ...prev,
      infos: {
        ...prev.infos,
        ...(isUserField
          ? {
              user: {
                ...prev.infos.user,
                [name]: value,
              },
            }
          : {
              [name]: value,
            }),
      },
    }));

    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: null,
      }));
    }
  };

  const validateField = (element, value) => {
    if (element.required && (!value || value.trim() === "")) {
      return `${t(element.label)} ${t("is required")}`;
    }

    if (element.type === "email" && value) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(value)) {
        return `${t(element.label)} ${t("must be a valid email")}`;
      }
    }

    return null;
  };

  return (
    <div className="flex-1 d-flex flex-column">
      <div className="modalContent px-5 pt-4 pb-5">
        <div className="row">
          {infoElements.map((element) => {
            const isUserField =
              element.name === "email" || element.name === "password";
            const value = isUserField
              ? forms?.infos?.user?.[element.name]
              : forms?.infos?.[element.name];
            element.required =
              element.name === "password"
                ? !isUpdate && value?.length > 0
                : element.required;

            return (
              <div key={element.name} className="col-md-6 mb-3">
                <label className="form-label">
                  {t(element.label)}
                  {element.required && <span className="text-danger">*</span>}
                </label>
                <TextInput
                  name={element.name}
                  type={element.type}
                  value={value || ""}
                  placeholder={t(element.placeholder)}
                  callback={(e) =>
                    handleInputChange(element.name, e.target.value)
                  }
                  onBlur={(e) => {
                    const error = validateField(element, e.target.value);
                    if (error) {
                      setErrors((prev) => ({
                        ...prev,
                        [element.name]: error,
                      }));
                    }
                  }}
                  className={errors[element.name] ? "border-danger" : ""}
                />
                {errors[element.name] && (
                  <div className="text-danger small mt-1">
                    {errors[element.name]}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default TransporterInformations;
